import { render, staticRenderFns } from "./olustur.vue?vue&type=template&id=f9350828&"
import script from "./olustur.vue?vue&type=script&lang=js&"
export * from "./olustur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports